import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-console-section',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="console-section">
      <h2 class="console-section__title">{{ title }}</h2>
      <p class="console-section__desc" *ngIf="description">{{ description }}</p>
      <ng-content></ng-content>
    </section>
  `,
})
export class ConsoleSectionComponent {
  @Input() title = '';
  @Input() description = '';
}
